<template>
    <div :class="['root', className]" :data-testid="dataTestId" :id="id">
        <div class="container">
            <div class="errorIcon">
                <img src="/images/error-page-image.svg" alt="Error Icon" />
            </div>

            <div class="title">{{ title || 'This page might need a tuneup...' }}</div>
            <div class="message">
                {{ message || 'Don’t worry, our team is working to fix this issue. Come back later or try refreshing your browser.' }}
            </div>

            <div class="buttons">
                <button class="btn btn-primary block" @click="onRefresh">Refresh</button>
                <button class="btn btn-outline-primary" @click="onHomeLinkClick">Go to Home Page</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        message: {
            type: String,
            default: ''
        },
        onRefresh: {
            type: Function,
            default: () => window.location.reload()
        },
        onHomeLinkClick: {
            type: Function,
            default: () => {window.location = '/'}
        },
        dataTestId: {
            type: String,
            default: ''
        },
        className: {
            type: String,
            default: ''
        },
        id: {
            type: String,
            default: ''
        }
    }
}
</script>

<style scoped>
.root {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    text-align: center;
    background-color: rgb(247, 249, 252);
    font-family: -apple-system, '.SFNSText-Regular', 'San Francisco', BlinkMacSystemFont, 'Segoe UI',
    'Helvetica Neue', Helvetica, Arial, sans-serif;

    direction: ltr;
    letter-spacing: normal;
    word-spacing: normal;
    cursor: default;
    white-space: normal;
    text-transform: none;
    text-indent: 0;
    margin: 0;
    font-variant: none;
    font-style: normal;
}

.container {
    display: flex;
    flex-direction: column;
    max-width: 450px;
    padding: 20px;
}

.errorIcon {
    margin-bottom: 20px;
}

.title {
    font-weight: 700;
    font-size: 22px;
    color: rgb(42, 50, 65);
    margin: 12px;
    line-height: 26px;
}

.message {
    font-weight: 400;
    font-size: 14px;
    color: rgb(42, 50, 65);
    line-height: 19px;
}

.buttons {
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    row-gap: 16px;
}

</style>